import { render, staticRenderFns } from "./table-year.vue?vue&type=template&id=3b7543a6"
import script from "./table-year.vue?vue&type=script&lang=js"
export * from "./table-year.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports